module.exports = __webpack_public_path__ + "static/media/ape.e899a157.png";